module.exports = __webpack_public_path__ + "media/src/img/payment/kseniya_sber_logo-8f04968723398a8d78f805884ac0697e.png";